import React from 'react';

const ProductField = ({ subs, value, onChange, validationError }) => {
  if (!subs || subs.length === 0) return null;

  const sortedSubs = [...subs].sort((a, b) => {
    const aDays = parseInt(a.name.match(/\d+/)?.[0] || 0);
    const bDays = parseInt(b.name.match(/\d+/)?.[0] || 0);
    return aDays - bDays;
  });

  return (
    <div className={`sf-product-field ${validationError ? 'sf-field-error' : ''}`}>
      {sortedSubs.map((sub) => (
        <label
          key={sub.id}
          className={`sf-product-option ${value === sub.id ? 'active' : ''}`}
        >
          <input
            type="radio"
            name="productType"
            value={sub.id}
            checked={value === sub.id}
            onChange={() => onChange(sub.id)}
            className="sf-product-radio"
          />
          <span className="sf-product-radio-circle">
            <span className="sf-product-radio-dot" />
          </span>
          <span className="sf-product-name">{sub.name}</span>
        </label>
      ))}
    </div>
  );
};

export default ProductField;
